import { useLocation } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import LoanproductViewPage from 'pages/loanproduct/View';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import UsersViewPage from 'pages/users/View';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
import axios from 'axios';
import { Toast } from 'primereact/toast';
const MandateworldListadminPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const location = useLocation();
	const utils = useUtils();
	const filterSchema = {
		mdate: {
			tagTitle: "Mdate",
			value: [],
			valueType: 'range-date',
			options: [],
		},
		customername: {
			tagTitle: "Customername",
			value: '',
			valueType: 'single',
			options: [],
		},
		userid: {
			tagTitle: "Userid",
			value: '',
			valueType: 'single',
			options: [],
		},
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue, setFilterOptions } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "View",
			command: (event) => { app.navigate(`/mandateworld/view/${data.loanaccountno}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('mandateworld/view')
		},
		{
			label: "Edit",
			command: (event) => { app.navigate(`/mandateworld/edit/${data.loanaccountno}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('mandateworld/edit')
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.loanaccountno) },
			icon: "pi pi-trash",
			visible: () => auth.canView('mandateworld/delete')
		},
		{
			label: "Delete With Child",
			command: (event) => { app.navigate(`/mandateworld/deleteall`) },
			icon: "pi pi-delete-left"
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function LoanaccountnoTemplate(data){
		if(data){
			return (
				<Link to={`/mandateworld/view/${data.loanaccountno}`}> { data.loanaccountno }</Link>
			);
		}
	}
	function CustomeremailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.customeremail}`}>{ data.customeremail }</a>
			);
		}
	}
	function FirstcollectiondateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.firstcollectiondate )}</>
			);
		}
	}
	function LastcollectiondateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.lastcollectiondate )}</>
			);
		}
	}
	function MdateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.mdate )}</>
			);
		}
	}
	function UseridTemplate(data){
		if(data){
			return (
				<>{data.userid && <Button className="p-button-text" icon="pi pi-eye" label="Users" onClick={() => app.openPageDialog(<UsersViewPage isSubPage apiPath={`/users/view/${data.userid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function LoanproductidTemplate(data){
		if(data){
			return (
				<>{data.loanproductid && <Button className="p-button-text" icon="pi pi-eye" label="Loanproduct" onClick={() => app.openPageDialog(<LoanproductViewPage isSubPage apiPath={`/loanproduct/view/${data.loanproductid}`} />, {closeBtn: true })} /> }</>
			);
		}
	}
	function PhotoTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.photo} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Loading...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					No record found
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Delete Selected"/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-mandateworld`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="" tooltip="Export" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Records <b>{ recordsPosition } of { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="mandateworld/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
let toastInstance = null;
function ActionButton(data){
    const items = [
    {
        label: "View",
        command: (event) => { app.navigate(`/mandateworld/view/${data.loanaccountno}`) },
        icon: "pi pi-eye",
        visible: () => auth.canView('mandateworld/view')
    },
    {
        label: "Edit",
        command: (event) => { app.navigate(`/mandateworld/edit/${data.loanaccountno}`) },
        icon: "pi pi-pencil",
        visible: () => auth.canView('mandateworld/edit')
    },
    {
        label: "Delete",
        command: (event) => { deleteItem(data.loanaccountno) },
        icon: "pi pi-trash",
        visible: () => auth.canView('mandateworld/delete')
    },
    {
        label: "Delete With",
        command: (event) => { deleteItemall(data.loanaccountno) },
        icon: "pi pi-trash",
        visible: () => auth.canView('mandateworld/delete')
    }
    ]
    .filter((item) => {
        if(item.visible){
            return item.visible()
        }
        return true;
    });
    return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
}
async function deleteItemall(loanAccountNo) {
    const token = localStorage.getItem('access_token');
    try {
        const response = await axios.get(`mandateworld/deleteall?id=${loanAccountNo}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    // Success
    if (toastInstance && toastInstance.show) {
        toastInstance.show({ 
            severity: 'success', 
            summary: 'Deleted', 
            detail: response.data.message || 'Record deleted successfully' 
        });
    }
    refreshGrid();
    } catch (error) {
    // Handle different error scenarios
    if (error.response) {
        switch (error.response.status) {
            case 401:
            toast.current.add({ severity: 'error', summary: 'Session Expired', detail: 'Please login again' });
            // Redirect to login
            setTimeout(() => {
                window.location.href = '/login';
            }, 2000);
            break;
            case 403:
            toast.current.add({ severity: 'error', summary: 'Forbidden', detail: 'You do not have permission to delete' });
            break;
            case 404:
            toast.current.add({ severity: 'error', summary: 'Not Found', detail: 'Record not found' });
            break;
            default:
            toast.current.add({ severity: 'error', summary: 'Error', detail: error.response.data?.message || 'Failed to delete' });
        }
        } else {
        toast.current.add({ severity: 'error', summary: 'Network Error', detail: 'Could not connect to server' });
    }
}
}
	return (
<main id="MandateworldListadminPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Mandate List/View"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/mandateworld/add`}>
                            <Button label="Add New Mandateworld" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <Title title="Filter by Mandate Date"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                            <div className="">
                                <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="range" value={filters.mdate.value} onChange={(e) => setFilterValue('mdate', e.value)} placeholder="Select date Range"   />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('customername', options)}  apiPath="components_data/customername_option_list"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Filter by Customer"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown filter={true} className="w-full" onChange={(e) => setFilterValue( 'customername', e.value)} value={filters.customername.value} optionLabel="label" optionValue="value" options={filters.customername.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 comp-grid" >
                        <div className="p-3 mb-3">
                            <DataSource onLoad={(options) => setFilterOptions('userid', options)}  apiPath="components_data/userid_option_list_4"  >
                                {
                                ({ response }) => 
                                <>
                                <Title title="Filter by Vendor"  headerClass="p-3" titleClass="font-bold text-primary" subTitleClass="text-sm text-500"      separator={false} />
                                <div className="">
                                    <Dropdown  className="w-full" onChange={(e) => setFilterValue( 'userid', e.value)} value={filters.userid.value} optionLabel="label" optionValue="value" options={filters.userid.options} placeholder="Select a value ..." >
                                    </Dropdown>
                                </div>
                                </>
                                }
                            </DataSource>
                        </div>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Search" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="loanaccountno" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="mid" header="Mid"  sortable={true} ></Column>
                                            <Column  field="loanaccountno" header="Loan Account No" body={LoanaccountnoTemplate}  ></Column>
                                            <Column  field="accountholdername" header="Account Name"   ></Column>
                                            <Column  field="accountnumber" header="Account Number"   ></Column>
                                            <Column  field="amounttype" header="Amount Type"   ></Column>
                                            <Column  field="accounttype" header="Account Type"   ></Column>
                                            <Column  field="authtype" header="Authentication Type"   ></Column>
                                            <Column  field="bankifsc" header="IFSC"   ></Column>
                                            <Column  field="collectionamount" header="Collection Amount"   ></Column>
                                            <Column  field="customeremail" header="Customer Email" body={CustomeremailTemplate}  ></Column>
                                            <Column  field="customermobile" header="Customer Mobile"   ></Column>
                                            <Column  field="customername" header="Customer Name"   ></Column>
                                            <Column  field="firstcollectiondate" header="First Collection Date" body={FirstcollectiondateTemplate}  ></Column>
                                            <Column  field="frequency" header="Frequency"   ></Column>
                                            <Column  field="lastcollectiondate" header="Last Collection Date" body={LastcollectiondateTemplate}  ></Column>
                                            <Column  field="merchanttrxnrefid" header="Merchant Trxn Refid"   ></Column>
                                            <Column  field="principalamount" header="Principal Amount"   ></Column>
                                            <Column  field="status" header="Status"   ></Column>
                                            <Column  field="trxnid" header="Trxnid"   ></Column>
                                            <Column  field="authorized" header="Authorized"   ></Column>
                                            <Column  field="cancelled" header="Cancelled"   ></Column>
                                            <Column  field="mdate" header="Mandate Date" body={MdateTemplate}  ></Column>
                                            <Column  field="mandate_id" header="Mandate ID"   ></Column>
                                            <Column  field="paymentmethod_token" header="Payment Method Token"   ></Column>
                                            <Column  field="instrumenttoken" header="Instrument Token"   ></Column>
                                            <Column  field="bankcode" header="Bank Code"   ></Column>
                                            <Column  field="userid" header="Userid" body={UseridTemplate}  ></Column>
                                            <Column  field="loanproductid" header="Loan Product Id" body={LoanproductidTemplate}  ></Column>
                                            <Column  field="interestrate" header="Interest Rate"   ></Column>
                                            <Column  field="processingfee" header="Processing Fee"   ></Column>
                                            <Column  field="loanterm" header="Loan Term"   ></Column>
                                            <Column  field="isamortgenerated" header="Isamortgenerated"   ></Column>
                                            <Column  field="photo" header="Photo" body={PhotoTemplate}  ></Column>
                                            <Column  field="pancard" header="Pancard"   ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
MandateworldListadminPage.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'mandateworld',
	apiPath: 'mandateworld/listadmin',
	routeName: 'mandateworldlistadmin',
	msgBeforeDelete: "Are you sure you want to delete this record?",
	msgTitle: "Delete record",
	msgAfterDelete: "Record deleted successfully",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default MandateworldListadminPage;
